// extracted by mini-css-extract-plugin
export default {"button":"styles_button__cLVM3","primaryButton":"styles_primaryButton__Z8Z+D","secondaryButton":"styles_secondaryButton__Vos+w","tertiaryButton":"styles_tertiaryButton__EGejr"};